import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = ({ t }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">BiteSite</h3>
            <p className="text-slate-400 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-slate-400">
                <Mail className="h-4 w-4" />
                <a
                  href={`mailto:${t.contact.info.email}`}
                  className="hover:text-white transition-colors duration-200"
                >
                  {t.contact.info.email}
                </a>
              </div>
              <div className="flex items-center space-x-3 text-slate-400">
                <Phone className="h-4 w-4" />
                <a
                  href={`tel:${t.contact.info.phone.replace(/\s/g, '')}`}
                  className="hover:text-white transition-colors duration-200"
                >
                  {t.contact.info.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3 text-slate-400">
                <MapPin className="h-4 w-4" />
                <span>{t.contact.info.location}</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">{t.nav.services}</h4>
            <ul className="space-y-2 text-slate-400">
              <li>Website Design</li>
              <li>Online Menus</li>
              <li>Mobile-First</li>
              <li>Reservations</li>
              <li>SEO</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400">
            © {currentYear} BiteSite - Erik M. Andersen. {t.footer.rights}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
